<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  progress: { type: Number, default: 0 },
  saving: { type: Boolean, default: false },
});

const emit = defineEmits(['complete']);
const { t } = useI18n();
const value = computed(() =>
  Math.min(100, Math.max(0, Number(props.progress) || 0))
);
const colorClass = computed(() => {
  if (value.value >= 100) return 'accent-lais-primary';
  if (value.value > 0) return 'accent-amber-500';
  return 'accent-lais-text-muted';
});
</script>

<template>
  <footer
    class="relative mb-[70px] border-t border-lais-border-soft bg-white px-[10px] py-[10px] shadow-lais-soft min-[701px]:sticky min-[701px]:bottom-0 min-[701px]:z-20 min-[701px]:mb-0 min-[701px]:px-[30px] min-[701px]:py-[14px]"
    data-test="commission-progress-footer"
  >
    <div class="mx-auto flex w-full items-center justify-between gap-3">
      <div class="mr-[10px] min-w-0 w-[70%]">
        <span
          class="text-base font-bold text-lais-text-muted min-[701px]:text-xl"
          data-test="commission-progress-value"
        >
          {{ t('SALES.COMMON.PERCENT', { value: value }) }}
        </span>
        <progress
          class="my-1.5 h-1.5 w-full rounded-full min-[701px]:my-2"
          :class="colorClass"
          :value="value"
          max="100"
          :aria-label="t('SALES.COMMISSION.FOOTER.PROGRESS')"
          data-test="commission-progress-bar"
        />
      </div>
      <LaisPrimaryButton
        :disabled="value !== 100"
        :is-loading="saving"
        size="lg"
        class="max-[700px]:hidden"
        data-test="commission-progress-complete"
        @click="emit('complete')"
      >
        {{ t('SALES.COMMISSION.FOOTER.COMPLETE') }}
      </LaisPrimaryButton>
    </div>
  </footer>
</template>
